import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PortfolioService } from '../portfolio.service';
import { Observable } from 'rxjs';
import { LoaderService } from '../../../../services/loader.service';
import { collapseTextChangeRangesAcrossMultipleVersions } from 'typescript';
declare var $:any;
@Component({
  selector: 'app-listportfoliodata',
  templateUrl: './listportfoliodata.component.html',
  styleUrls: ['./listportfoliodata.component.css'],
  providers: [PortfolioService]
})
export class ListportfoliodataComponent implements OnInit {

	portfolio: any=[];
  public spaces = [];
  public segments = ['Home','Office'];
  public themes = [];
  public lifestages = [];
  public elements = [];
  private lifestageFlag = false;
  private elementsFlag = false;

  segment : string;
  theme : string;
  element : string;
  space : string;
  attachment_file : any;
  lifestage : string;
  price_cents: string;
  preset_number: any;
  preset_name :any
  space_area: any;
  space_shape: any;
  city: any;
  apartment_name: any;
  preset_type: any;
  format: any;
  variant_id: any;
  boq_value: any;
  boq_number: any;
  user_story_title: string;
  portfolio_data: any;
  description: string;
  imgsrc: string;
  secondaryImage: any;
  attachment_File: any;
  attachment_name: string;
  basefile = {};
  basefileSecondary = {};
  submitted = false;
  id: number;
  p:any;
  loader :boolean;
  errorMessage : string;
  erroralert = false;
  successalert = false;
  successMessage : string;
  search = '';
  city_list: any;
  differentShapes :any
  is_featured :any
  submit_isfeatured:any;
  showhideforSpaceFilter: boolean = false;
  plusMoreBoolean : boolean = false
  current_page ;
  design_file :any
  updated_spaceName = [
    {id : 1, name : 'Kitchen'},
    {id : 2, name : 'Living'},
    {id : 3, name : 'Kids Room'},
    {id : 4, name : 'Master Bedroom'},
    {id : 5, name : 'Guest Bedroom'},
    {id : 6, name : 'Dining Room'},
    {id : 7, name : 'Bedroom'},
  ];
  updated_segmentName = [
    {id : 1, name : 'Home'},
    {id : 2, name : 'Office'},
  ];
  updated_priceName = [
    {
      name: "Under 2 Lakh", paramvalue : '2', id: 'p1'
    },
    { name: "2 - 4 Lakh", paramvalue : '2-4', id: 'p2'},
    { name: "4 - 6 Lakh", paramvalue : '4-6', id : 'p3' },
    { name: "6 - 8 Lakh", paramvalue : '6-8', id: 'p4'},
    { name: "8 - 10 Lakh", paramvalue : '8-10' , id: 'p5'},
    { name: "> 10 Lakh", paramvalue : '10' , id: 'p5'}
  ];
  updated_stateName = [
    {id : 1, name : 'Active', value:'true'},
    {id : 2, name : 'Inactive', value: 'false'},
  ];
  filterValue: boolean = false;
  constructor(
  	private router: Router,
    private portfolioService:PortfolioService,
    private loaderService : LoaderService
  ) { }

  ngOnInit() {
    this.getpage("");
    this.getBOQvalues('');
    this.getCities();
    if(this.current_page == undefined){
      this.current_page =1;
    }
    this.differentShapes = [
      {value : 'rectangle' , name: 'Rectangle'},
      {value : 'square' , name: 'Square'},
      {value : 'l_shaped' , name: 'L Shaped'},
      {value : 'round' , name: 'Round'},
      {value : 'open' , name: 'Open'}
    ]
  }
  ngAfterViewInit() {
        $('[data-toggle="tooltip"]').tooltip();
  }

  

  confirmAndDelete(id:number) {
    if (confirm("Are You Sure") == true) {
      this.DeletePortfolio(id);
    }
  }

  private DeletePortfolio(id:number){
    this.loaderService.display(true);
     this.portfolioService.deletePortfolio(id).subscribe(
        portfolio => {
          this.successalert = true;
          this.successMessage = "Portfolio Deleted Successfully !!";
          $(window).scrollTop(0);
          setTimeout(function() {
                this.successalert = false;
            }.bind(this), 2000);
        
          this.loaderService.display(false);
          this.getpage(this.current_page);
        },
        error =>  {
          this.erroralert = true;
          this.errorMessage = <any>JSON.parse(error['_body']).message;
          $(window).scrollTop(0);
          setTimeout(function() {
                this.erroralert = false;
            }.bind(this), 2000);
           this.loaderService.display(false);
        }
    );
  }

  space_item: any = [];
  finalid: any;
  varientIdimage: any;
  unidImage: any;
  search_word: any  = ' ';
  checkPresetfile :any 
  presetfileName :any 
  private getPortfolio(id: number) {
    this.cancelTopDownImage = true
    this.showAndHidePreviewTopDownImage = true;
    this.fileName = 'image 1',
    (<HTMLInputElement>document.getElementById(`presetfileupload`)).value = ''
    this.filedelete = 'ongetdata'
    this.errormsgpresetfile = ''
    this.checkfileSizeMb = false
    this.checkpresetfileuploda = true
    this.finalid = id;
    this.portfolioService.viewPortfolioData(id).subscribe(
      res => {
        this.segment = res.portfolio.segment;
        this.imgsrc = res.portfolio.attachment_file;
        this.secondaryImage = res.portfolio.contents;
        this.firstDropDownChanged(this.segment);
        this.element = res.portfolio.element;
        this.space = res.portfolio.space;
        this.spaceDropDownChanged(this.space);
        this.theme = res.portfolio.theme;
        this.lifestage = res.portfolio.lifestage;
        this.price_cents = res.portfolio.price_cents;
        this.preset_number = res.portfolio.preset_number;
        this.preset_name = res.portfolio.preset_name
        this.space_area = res.portfolio.space_area;
        this.space_shape = res.portfolio.space_shape;
        this.is_featured = res.portfolio.featured
        this.checkPresetfile = res.portfolio.design_file
        this.presetfileName = res.portfolio.design_file_file_name
        if (res.portfolio.apartment.length === 0) {
          this.city = null;
          this.apartment_name = null;
          this.format = null;
          this.variant_id = null;
        }
        else {
          this.city = res.portfolio.apartment[0].city;
          this.apartment_name = res.portfolio.apartment[0].apartment_name;
          this.format = res.portfolio.apartment[0].format;
          this.variant_id = res.portfolio.apartment[0].variant_id;
          this.varientIdimage = res.portfolio.apartment[0].id;
        }
        this.preset_type = res.portfolio.preset_type;
        this.description = res.portfolio.description;
        this.boq_number = res.portfolio.boq_number;
        this.boq_value = res.portfolio.boq_value;
        this.user_story_title = res.portfolio.user_story_title
        this.portfolio_data = (res.portfolio.portfolio_data != null) ? JSON.stringify(res.portfolio.portfolio_data) : 'NA';
        this.space_item = res.portfolio.space_items;
        // this.attachment_file = res.portfolio.attachment_file;
        this.getLifeSatgeData();
        this.societySearch(this.city, '');
        for (let i = 0; i < this.space_item.length; i++) {
          this.selected_space_item.push(
            this.space_item[i].id
          )
        }
        
        // this.getLifeSatgeData();
        this.getSpaceItems(this.space);
      },
      error => {
          
      }

    );
    
  }
  /*-- edit portfolio methods -- */

  firstDropDownChanged(val: any) {
    if (val == "Home") {
      this.space ='';
      this.spaces = ["Kitchen", "Bedroom", "Living", "Kids Room","Master Bedroom","Guest Bedroom"," Dining Room","All Spaces"];
      this.themes = [
        "All",
        "Minimalist",
        "Transitional",
        "Contemporary",
        "Modern",
        "Rustic Industrial",
        "Indian Ethnic",
        "Dark Knight",
        "Dream Ballet",
        "Modica",
        "Morandi",
        "Urban Elegance",
        "Modern Chic",
        "Golden Murano",
        "Macaron",
        "Other",
      ];
      this.elements = ['Master Bedroom','Kids Room', 'Wardrobe'];
      // this.lifestages = ['Bachelor','Working Couple','Large Families','Old Age'];
    }
    else if (val == "Office") {
      this.space ='';
      this.spaces = ["Conference", "Reception", "Workstations"];
      this.themes = ['Minimalist','Transitional','Contemporary','Modern','Rustic Industrial','Other'];
      this.lifestages = [];
      this.elements = [];
    }
    else {
      this.spaces = [];
      this.themes = [];
      this.elements = [];
      this.lifestages = [];
    }
  }

  spaceDropDownChanged(val: any) {
    if (val == 'Kitchen'){
      // this.lifestages = ['Bachelor','Working Couple','Large Families','Old Age'];
      this.themes = [
        "Minimalist",
        "Transitional",
        "Contemporary",
        "Modern",
        "Rustic Industrial",
        "Other",
        "Lifestage Kitchen",
        "Dark Knight",
        "Dream Ballet",
        "Modica",
        "Morandi",
        "Urban Elegance",
        "Modern Chic",
        "Golden Murano",
        "Macaron"
      ];
      this.element='';
      this.theme = "";
      this.lifestageFlag = true;
      this.elementsFlag = false;
    }
    else if (val == 'Bedroom') {
      // this.lifestage='';
      this.elements = ['Master Bedroom','Kids Room', 'Wardrobe'];
      this.lifestageFlag = false;
      this.elementsFlag = true;
      this.theme = "";
    }
    else if(val == 'Living'){
      // this.lifestage='';
      this.theme = "";
      this.themes = [
        "Minimalist",
        "Transitional",
        "Contemporary",
        "Modern",
        "Rustic Industrial",
        "Indian Ethnic",
        "Other",
        "Dark Knight",
        "Dream Ballet",
        "Modica",
        "Morandi",
        "Urban Elegance",
        "Modern Chic",
        "Golden Murano",
        "Macaron"
      ];
      this.element='';
      this.lifestageFlag = false;
      this.elementsFlag = false;
    } 
    else if(val == 'Kids Room'){
      // this.lifestage='';
      this.theme = "";
      this.themes = [
        "Minimalist",
        "Transitional",
        "Contemporary",
        "Modern",
        "Rustic Industrial",
        "Indian Ethnic",
        "Other",
        "Dark Knight",
        "Dream Ballet",
        "Modica",
        "Morandi",
        "Urban Elegance",
        "Modern Chic",
        "Golden Murano",
        "Macaron"
      ];
      this.element='';
      this.lifestageFlag = false;
      this.elementsFlag = false;
    }
    else {
      // this.lifestage ='';
      this.element ='';
    }
    this.getSpaceItems(val);
    this.selected_space_item = [];
    this.space_item = []
  }

  themeDropDownChanged(val:any,i:number){
    if(val=='Lifestage Kitchen') {
      this.lifestageFlag[i] = true;
    } else {
      this.lifestageFlag[i] = false;
    }
  }
  searchstring:any;
  totalpage:any;
  total_page:any;
  pagination:any;
  perpage:any =10;
  getPageNumber(event){
    this.current_page = event;
    this.pagination = event;
    // this.getpage()
   
  }
  getpage(event: any){
    this.current_page = event;
    if(this.current_page == undefined){
      this.current_page = 1;
    }
   
    if(this.searchstring == undefined){
      this.searchstring = '';
    }
    if(this.ValueUpdate == undefined){
      this.ValueUpdate = ''
    }
    if(this.finalid == undefined){
      this.finalid = ''
    }
    if(this.updatedStateArray == undefined){
      this.updatedStateArray = ''
    }
    this.loaderService.display(true);
    this.portfolioService.getPortfolioListof(this.searchstring,this.current_page,this.perpage,this.updatedPriceArray,this.updatedSegmentArray,this.updatedStateArray,this.updatedSpaceArray).subscribe(res=>{
      let portfolio = JSON.parse(res._body);
      this.total_page = portfolio.count;
      this.current_page = portfolio.page_number
       this.portfolio = portfolio.portfolios ;
       this.loaderService.display(false);
       
    },
    err=>{
      this.loaderService.display(false);
    })
  }
  ValueUpdate :any
  updateStatus(event,id){
    console.log(event);
    console.log(event.target.checked);
    if(event.target.checked){
      this.ValueUpdate = true
    }else {
      this.ValueUpdate = false
    }
    this.finalid = id;
    // this.getpage(this.current_page)
    this.updateStatusSpace(this.ValueUpdate , this.finalid)
  }
  updateStatusSpace(value , id){
    this.loaderService.display(true);
    this.portfolioService.updateStatusActiveInActive(id,value).subscribe(res => {
      this.loaderService.display(false);
      console.log(res);
    },(err) => {
      this.loaderService.display(false)
    })
  }
  
  showAndHidePreviewTopDownImage : boolean = false
  fileName:any;
  onChange(event) {
    this.showAndHidePreviewTopDownImage = false
    this.attachment_File = event.srcElement.files[0];
    this.fileName = event.target.files[0].name
    var fileReader = new FileReader();
    var base64;
    fileReader.onload = (fileLoadedEvent) => {
      base64 = fileLoadedEvent.target;
      this.basefile = base64.result;
      this.imgsrc = base64.result;
    };
    fileReader.readAsDataURL(this.attachment_File);
  }
  cancelTopDownImage : any
  onCancelSingleImages(){
    this.cancelTopDownImage = false
    this.attachment_File = {}
    this.basefile = "";
    this.fileName = "";
    this.imgsrc = ""
  }

  attachment_file_secondary: any;
  attachement_files = [];
  imageNamess = [];
  imageName = [];
  lengthVal:any;
  onChangeSecondary(event) {
    this.lengthVal = this.secondaryImage.length + this.imageName.length
    if (event.target.files && event.target.files[0]) {
      var filesAmount = event.target.files.length;
      for (let i = 0; i < filesAmount; i++) {
        var reader = new FileReader();
        var base64;
        if(this.lengthVal < 5){
          reader.onload = (fileLoadedEvent) => {
            var image = new Image();
            base64 = fileLoadedEvent.target;
                  
                  this.attachement_files.push(base64.result); 
          }
        }
        reader.readAsDataURL(event.target.files[i]);
        if(this.lengthVal < 5){
          this.imageName.push({"name":event.target.files[i].name, "size":Number(event.target.files[i].size/1024000).toFixed(2)});
        }else{
          alert('Max 5 Images can be Uploaded');
        }
        // this.imageNamess.push(event.target.files[i].name);
      }

  }
   
  }

  onMultiCancelImg(i) {
    this.attachement_files.splice(i,1);
    this.imageName.splice(i,1);
  }

  finalVarient: any = [];
  onSubmit(data) {
    if(this.submit_isfeatured=== undefined){
      this.submit_isfeatured = this.is_featured
    }

    let  presetfileupload ,nameofpreset

    if(this.filedelete == 'deletefile' && this.convertpresetfile === undefined){
      presetfileupload = ''
    }else{
      presetfileupload = this.convertpresetfile
      nameofpreset = this.namepresetfile
    }


   $('#exampleModalLong').modal('hide');
    this.loaderService.display(true);
    this.imgsrc = "";
    data.attachment_file = this.basefile;
    data.attachment_file_secondary = this.attachement_files;
    data.design_file = this.convertpresetfile;
    if (this.xyz.length === 0) {
      this.finalVarient = this.varientIdimage;
    }
    else if (this.xyz.length === undefined) {
      this.finalVarient = this.xyz;
    }
    let obj = {
      portfolio: {
        'segment': data.segment,
        'theme': data.theme,
        'element': (data.segment == 'Home' && data.space == 'Bedroom') ? data.element : '',
        'space': data.space,
        'attachment_file': data.attachment_file,
        'lifestage': data.lifestage,
        'price_cents': data.price_cents,
        'preset_number': data.preset_number,
        'preset_name' : data.preset_name,
        'preset_type' :data.preset_type,
        'space_area': parseInt(data.space_area),
        'space_shape': data.space_shape,
        'contents': data.attachment_file_secondary,
        'apartments': [this.finalVarient],
        'boq_value': parseInt(this.boq_value),
        'boq_number': data.boq_number,
        'description': data.description,
        'user_story_title' : data.user_story_title,
        'is_featured' : this.submit_isfeatured,
        'design_file' : presetfileupload,
        'design_file_file_name' : nameofpreset,
        'portfolio_data' : (data.portfolio_data!="" && data.portfolio_data!=null && 
           data.portfolio_data != undefined && data.portfolio_data != "NA") ? (data.portfolio_data) : '',
        'space_items': this.selected_space_item.length > 0 ? this.selected_space_item : this.space_item
       }
     }
    this.submitted = true;
    this.portfolioService.editPortfolio(this.finalid,obj)
    .subscribe(
        res => {
         this.loaderService.display(false);
         this.successalert = true;
         this.basefile = undefined;
         this.convertpresetfile = undefined
        this.successMessage = "Portfolio Updated Successfully !!";
        this.imageNamess = [];
        this.attachement_files = [];
         setTimeout(function() {
               this.successalert = false;
           }.bind(this), 2000);
         //$.notify('Updated Successfully!');
         this.getpage(this.current_page);
        },
        error => {
           this.loaderService.display(false);
           this.erroralert = true;
           this.errorMessage = JSON.parse(error['_body']).message;
           setTimeout(function() {
                 this.erroralert = false;
             }.bind(this), 2000);
          //$.notify(JSON.parse(error['_body']).message);
        }
    );
  }
  tooltipHide(){
    $('.add').tooltip('hide')
  }

  onItemChange(e){
    console.log(e)
    this.submit_isfeatured = e
  }


  transform(value: string): string {
    return value.replace(/_/g, ' ');
  }

  selected_space_item: any = [];
  isAllSelected(e, i) {
    if (e.target.checked) {
      this.selected_space_item.push(parseInt(e.target.value))
    }
    else {
      const index =  this.selected_space_item.indexOf(parseInt(e.target.value));
      if (index > -1) {
        this.selected_space_item.splice(index, 1);
      }
    }
    
  }

  lifeStage: any;
  getLifeSatgeData() {
    this.portfolioService.getLifeStage().subscribe(
      res=>{
        this.lifestages = res;
      },
      err=>{
        this.loaderService.display(false);
      }
    );
  }

  other_space_item:any = []
  getSpaceItems(val) {
    this.portfolioService.getOther(val).subscribe(
      res=>{
        this.other_space_item = [];
        // this.other_space_item = res.data;
        for (let i = 0; i < res.data.length; i++){
          
          const a = this.selected_space_item.indexOf(parseInt(res.data[i].attributes.id));
          if (a == -1) {
            this.other_space_item.push(res.data[i].attributes)
          }
        }
        
      },
      err=>{
        this.loaderService.display(false);
      }
    );
  }

  selectLifeStage(val){
    this.lifestage = val;
    
  }

  // boq_reference_number_value: any;
  boq_dropdown: any;
  getBOQvalues(event: any) {
    this.boq_number = event;
    if (this.boq_number === undefined) {
      this.boq_number = ''
    }
    this.portfolioService.getBoqValues(this.boq_number).subscribe(
      res => {
        this.boq_dropdown = res;
        
      }
    )
  }

  searchBOQ(event: any) {
    let searchWord = event.target.value;
    this.getBOQvalues(searchWord);
  }
  BOQAmount: any;
  getsBOQnumber(event: any) {
    if(event){
      this.boq_number = event;
      let obj = this.boq_dropdown.find( (elem:any) => elem.reference_number ===  this.boq_number);
      this.boq_value = obj.total_amount;
    }else{
      this.boq_value = null
      this.boq_number = null
    }
  }

  getCities() {
    this.portfolioService.getCities().subscribe(res => {
      this.city_list = res.cities;
      
      
    })
  }
  selectedCity: any;
  getscityList(event: any) {
    this.selectedCity=event;
   this.societySearch(this.selectedCity,this.search);
  }

  searchSociety(event:any) {
    let searchWord = event.target.value;
    this.societySearch(this.selectedCity,searchWord)
  }

  selectedBuilding:any;
  getselectedbuilding(event: any) {
  this.selectedBuilding = event;
  let obj = this.societyList.find( (elem:any) => elem.id ===  this.selectedBuilding);
  // this.buildingName = obj.building_name;
 this.flatsizeType(event) ;
  }
  searchCity(event: any) {
    let searchcity = event.target.value;
  }
  
  flatsize:any;
storesize:any;
  flatsizeType(id: any) {
    this.portfolioService.flatsizetype(id).subscribe(data => {
      this.format = '';
      this.variant_id = '';
     this.storesize= data; 
    this.flatsize = this.storesize.varients;
    // this.getVarientDetaisls();
  })
  } 

  societyList = [];
  societySearch(city_name, search) {
    this.portfolioService.getLocalityBuildingDetails(city_name, search).subscribe(
      res => {
        this.societyList = res.data;
        
        if (this.societyList.length === 0) {
          this.xyz = '';
        }
      },
      err => {
      }
    );
  }
  selectedBuildingtype: any;
  areaType: any;
  getselectedbuildingtypes(event: any) {
    this.selectedBuildingtype = event;
    
    this.getVarientDetaisls();
   let obj = this.flatsize.find( (elem:any) => elem.area ===  this.selectedBuildingtype);
    this.areaType = obj.type;
    this.getVarientDetaisls();
  }

  varientId: any;
  getVarientDetaisls() {
    if (this.selectedBuildingtype === undefined) {
      this.selectedBuildingtype = ''
    }
    this.portfolioService.getVarientDetails(this.selectedBuilding, this.selectedBuildingtype).subscribe(
      res => {
        
        this.varientId = res;
      }
    )
  }

  xyz: any = [];
  isAllVarient(e) {
    this.xyz = e;
    
  }

  deleteContent(id: any) {
    console.log(this.secondaryImage.length);
    if(this.secondaryImage.length > 1){
      if(confirm("Are you sure you want to delete the image?") === true){
        this.portfolioService.deletePortfolioContent(id).subscribe(portfolio => {
          this.successalert = true;
          this.successMessage = "Image Deleted Successfully !!";
          setTimeout(function() {
            this.successalert = false;
          }.bind(this), 2000);
          this.getPortfolio(this.finalid);
        }); 
        }
    }else {
      alert('Atleast one image is required')
    }
  }

  
  showhideforstateFilter : boolean = false
  showhideforpriceFilter : boolean = false
  showhideforsegmentFilter : boolean = false
  showHideForFilters(type :any){
    if(type == 'space'){
      this.showhideforSpaceFilter = !this.showhideforSpaceFilter
    }else if(type == 'state'){
      this.showhideforstateFilter = !this.showhideforstateFilter
    }else if(type == 'price'){
      this.showhideforpriceFilter = !this.showhideforpriceFilter
    }else if(type == 'segment'){
      this.showhideforsegmentFilter = !this.showhideforsegmentFilter
    }
  }

  plusMoretheme : boolean = false
  plusMore(type :any){
    if(type == 'space'){
      this.plusMoreBoolean = !this.plusMoreBoolean
    }
    if(type == 'theme'){
      this.plusMoretheme = !this.plusMoretheme
    }
  }

  updatedSpaceArray:any = [];
  spaceFilterUpdated(event:any,data: any, id) {
    if(event.target.checked === true){
      this.updatedSpaceArray.push(data)
      
    }else{
      var index = this.updatedSpaceArray.indexOf(data);
      this.updatedSpaceArray.splice(index, 1);
      
    }
  }
  updatedStateArray: any

  // areaRangeUpdated(event:any,param: any) {
  //   this.updatedAreaRangeArray = event.target.value
  //   this.optimizationfunctionforpresetfilters()

  // }

  stateFilterUpdated(event:any,data: any, id:any, value:any) {
    // if(event.target.checked === true){
    //   this.updatedStateArray.push(value)
      
    // }else{
    //   var index = this.updatedStateArray.indexOf(value);
    //   this.updatedStateArray.splice(index, 1);
      
    // }
    this.updatedStateArray = value
  }

  updatedSegmentArray: any =[];
  segmentFilterUpdated(event:any,data: any, id) {
    if(event.target.checked === true){
      this.updatedSegmentArray.push(data)
      
    }else{
      var index = this.updatedSegmentArray.indexOf(data);
      this.updatedSegmentArray.splice(index, 1);
      
    }
  }

  updatedPriceArray: any =[];
  priceFilterUpdated(event:any,data: any, id, paramvalue) {
    if(event.target.checked === true){
      this.updatedPriceArray.push(paramvalue)
      
    }else{
      var index = this.updatedPriceArray.indexOf(paramvalue);
      this.updatedPriceArray.splice(index, 1);
      
    }
  }

  removeAllFilter(){
    this.updatedPriceArray = [];
    this.updatedSegmentArray = [];
    this.updatedStateArray = '';
    this.updatedSpaceArray = [];
    this.filterValue = false;
    // document.querySelectorAll('input[type=checkbox]').forEach((ele:any) => ele.checked = false);
    $('.apply_border_bottom_filters input:checkbox').prop('checked', false);
    $('.apply_border_bottom_filters input:radio').prop('checked', false);
    this.loaderService.display(true);
    this.portfolioService.getPortfolioListof(this.searchstring,this.current_page,this.perpage,this.updatedPriceArray,this.updatedSegmentArray,this.updatedStateArray,this.updatedSpaceArray).subscribe(res=>{
      let portfolio = JSON.parse(res._body);
      this.total_page = portfolio.count;
      this.current_page = portfolio.page_number
       this.portfolio = portfolio.portfolios ;
       this.loaderService.display(false);
       
    },
    err=>{
      this.loaderService.display(false);
    })

  }

  validateButton(){
    if( this.theme =='' || this.preset_name == ''){
      return true
    }else{
      return false
    }
  }
  onApplyFilter(){
    if(this.updatedPriceArray.length > 0 || this.updatedSegmentArray.length > 0 || this.updatedSpaceArray.length > 0 || this.updatedPriceArray.length > 0 ){
      this.filterValue = true;
    }else{
      this.filterValue = false;
    }
    this.loaderService.display(true);
    this.portfolioService.getPortfolioListof(this.searchstring,this.current_page,this.perpage,this.updatedPriceArray,this.updatedSegmentArray,this.updatedStateArray,this.updatedSpaceArray).subscribe(res=>{
      let portfolio = JSON.parse(res._body);
      this.total_page = portfolio.count;
      this.current_page = portfolio.page_number
       this.portfolio = portfolio.portfolios ;
       this.loaderService.display(false);
       
    },
    err=>{
      this.loaderService.display(false);
    })
  }

  convertpresetfile :any
  fileuploadforpreset :any
  file_name_preset:any = ''
  errormsgpresetfile :any
  checkpresetfileuploda : boolean = true
  checkfileSizeMb : boolean = false
  namepresetfile :any
  onImagePicked(event) {
    this.design_file = event.srcElement.files[0];

    this.namepresetfile = event.srcElement.files[0].name
    console.log(this.namepresetfile);
    this.presetfileName = event.srcElement.files[0].name

    this.checkpresetfileuploda = false
    console.log(this.design_file.size);
    if(this.design_file.size/1024/1024 > 500 ){
      this.errormsgpresetfile = 'File must be less than 500 MB'
      this.checkfileSizeMb = true
    }else{
      this.errormsgpresetfile = ''
      this.checkfileSizeMb = false
    }
    this.fileuploadforpreset = event.target.files[0] || event.srcElement.files[0];
    var fileReader = new FileReader();
    var base64;
    fileReader.onload = (fileLoadedEvent) => {
      base64 = fileLoadedEvent.target;
      this.convertpresetfile = base64.result;
    };
    fileReader.readAsDataURL(this.design_file);
  }

  onCancelPresetFile(){
    this.convertpresetfile = "";
    this.design_file = {};
    this.namepresetfile = ""
  }
  
  filedelete :any
  deletepresetfile(){
    this.filedelete = 'deletefile'
  }
}



// WEBPACK FOOTER //
// ./src/app/platform/organisation/portfolio/listportfoliodata/listportfoliodata.component.ts